import { useSessionStorageState } from 'ahooks';

export const DEFAULT_SEARCH_PRE_COLLECT_VALUE = '-1';
export const DEFAULT_SEARCH_PRE_COLLECT_LABEL_ID = '未分类';
export const DEFAULT_SEARCH_PRE_COLLECT = {
  label: DEFAULT_SEARCH_PRE_COLLECT_LABEL_ID,
  value: DEFAULT_SEARCH_PRE_COLLECT_VALUE,
};

export default () => {
  const [searchPreCollect, setSearchPreCollect] = useSessionStorageState<any>(
    'use-local-storage-state-search-pre-collect',
    { defaultValue: DEFAULT_SEARCH_PRE_COLLECT },
  );
  return {
    searchPreCollect,
    setSearchPreCollect,
  };
};
